<template>
  <a-form-model class="form" :model="form" label-position="top" size="mini">
    <a-form-model-item label="标签列表">
      <div class="item-list">
        <a-form-model
          class="item-form"
          label-position="top"
          size="mini"
          v-for="(t, i) in items"
          :key="i"
        >
          <a-form-model-item label="标签名称">
            <a-input v-model="t.title" placeholder="标签名称"></a-input>
          </a-form-model-item>
          <!-- <el-form-item label="选择组件">
                        <el-select v-model="t.controls" placeholder="请选择组件"
                                    value-key="type"
                                    @change="handleSelect"
                        >
                            <el-option
                                v-for="item in controls"
                                :key="item.type"
                                :label="item.title"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item> -->
          <!-- <el-form-item label="组件配置" v-if="t.controls">
                        <div class="setting-form">
                        </div>
                    </el-form-item> -->
          <a-icon type="close" class="icon-close" @click="remove(i)" />
        </a-form-model>
      </div>
      <div class="add-item" @click="addItem">
        <div class="add-icon"></div>
        <div class="add-txt">添加标签</div>
      </div>
    </a-form-model-item>
    <a-form-model-item label="选中标签颜色">
      <colorPicker
        class="color-picker shadow"
        v-model="form.color"
      ></colorPicker>
    </a-form-model-item>
    <a-form-model-item label="标签分割线">
      <a-switch v-model="form.line"></a-switch>
    </a-form-model-item>
    <template v-if="form.bar">
      <a-form-model-item label="选中指示条">
        <a-switch v-model="form.bar.show"></a-switch>
      </a-form-model-item>
      <a-form-model-item label="指示条颜色">
        <colorPicker
          class="color-picker shadow"
          v-model="form.bar.color"
          v-if="form.bar.show"
        ></colorPicker>
      </a-form-model-item>
    </template>
    <a-form-model-item label="高度">
      <a-input type="number" v-model="form.height"></a-input>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        class="color-picker top shadow"
        v-model="form.backgroundColor"
      ></colorPicker>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import controls from "../../common/js/controls";
import { clone } from "../../common/js/tool";

export default {
  name: "tabs-edit",
  props: {
    value: Object,
  },
  data() {
    return {
      form: {},
      items: [],
      controls: [],
      config: {},
      type: "",
    };
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
    this.setControls();
  },
  methods: {
    setControls() {
      controls.forEach((item) => {
        if (item.type === "tabs" || item.type === "nav") {
          return;
        }
        this.controls.push(item);
      });
    },
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        this.items = temp.list;
        delete temp.list;
        this.form = temp;
      }
    },
    addItem() {
      this.items.push({ title: null, controls: [] });
    },
    remove(i) {
      this.items.splice(i, 1);
    },
    update() {
      let temp = clone(this.form);
      temp.list = clone(this.items);
      this.$emit("change", temp);
    },
    validate() {
      let msg = null;
      let items = this.items;
      for (let i = 0, l = items.length; i < l; i++) {
        let item = items[i];
        if (!item.title) {
          msg = `请输入第${i + 1}个标签名称`;
        }
        if (msg) {
          break;
        }
      }
      return msg;
    },
    handleSelect(val) {
      //console.log(val)
      let config = val.config;
      this.type = val.type;
      config.more = null;
      config.padding = null;
      config.margin = null;
      config.isShow = null;
      this.config = config;
      //console.log(this.config)
    },
    handleConfigChange(config) {
      //修改后的config
      console.log("newConfig", config);
      console.log("oldItems", this.items);
      //this.$set(this.items[0].controls,'config',config)
      //console.log(this.items)
    },
  },
};
</script>

<style lang="less" scoped>
.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
